<template>
  <div v-if="isLoading == false">
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        height: 50px;
      "
    >
      <img
        src="@/assets/back-office/icons/chevron_icon_left.svg"
        alt=""
        width="30px"
        @click="
          $router.replace({
            path: `/weserve_admin_login/-/manager-manage/${$route.params.manager_id}/${$route.params.manager_name}/${$route.params.province_id}/invoice`,
          })
        "
        style="cursor: pointer"
      />
      <h2 class="text-xs-center">Edit Invoice</h2>
      <div></div>
    </div>
    <v-card class="mt-3">
      <v-card-text>
        <v-form v-model="valid" ref="forms" lazy-validation>
          <v-layout wrap justify-space-between>
            <v-flex xs12 sm4 class="px-4 pt-3">
              <v-select
                :items="districtList"
                item-text="district_name_th"
                item-value="district_id"
                label="เลือกพื้นที่"
                outline
                :rules="[(v) => !!v || '']"
                v-model="form.bill_district_id"
              ></v-select
            ></v-flex>
            <v-flex xs12 sm4 class="px-4 pt-3">
              <v-select
                :items="billTypeList"
                item-text="bill_type_name"
                item-value="bill_type_id"
                label="ประเภทของใบแจ้งชำระหนี้"
                outline
                :rules="[(v) => !!v || '']"
                v-model="form.bill_type"
                @change="changeInvoiceType()"
              ></v-select></v-flex
            ><v-flex xs12 sm4 class="px-4 pt-3">
              <v-text-field
                label="คำอธิบาย"
                placeholder="ระบุคำอธิบาย"
                outline
                :rules="[(v) => !!v || '', rules.lessThan50]"
                counter="50"
                v-model="form.bill_description"
              ></v-text-field></v-flex
          ></v-layout>
          <hr class="new2 my-4" />
          <v-layout wrap justify-space-between
            ><v-flex xs12 sm6 class="px-4 pt-3">
              <v-text-field
                label="ผู้ออก"
                placeholder="ระบุข้อมูลผู้ออก"
                outline
                :rules="[(v) => !!v || '', rules.lessThan50]"
                counter="50"
                v-model="form.bill_issuer_name"
              ></v-text-field></v-flex
            ><v-flex xs12 sm6 class="px-4 pt-3">
              <v-text-field
                label="ชื่อลูกค้า"
                placeholder="ระบุชื่อลูกค้า"
                outline
                :rules="[(v) => !!v || '', rules.lessThan50]"
                counter="50"
                v-model="form.bill_customer_name"
              ></v-text-field
            ></v-flex>
            <v-flex xs12 sm6 class="px-4 pt-3">
              <v-text-field
                label="ที่อยู่ผู้ออก"
                placeholder="ระบุที่อยู่ผู้ออก"
                outline
                :rules="[(v) => !!v || '', rules.lessThan150]"
                counter="150"
                v-model="form.bill_issuer_address"
              ></v-text-field></v-flex
            ><v-flex xs12 sm6 class="px-4 pt-3">
              <v-text-field
                label="ที่อยู่ลูกค้า"
                placeholder="ระบุที่อยู่ลูกค้า"
                outline
                :rules="[(v) => !!v || '', rules.lessThan150]"
                counter="150"
                v-model="form.bill_customer_address"
              ></v-text-field
            ></v-flex>
            <v-flex xs12 sm6>
              <v-layout wrap justify-space-between>
                <v-flex xs12 sm7 class="px-4 pt-3">
                  <v-text-field
                    label="เลขประจำตัวผู้เสียภาษี"
                    placeholder="ระบุเลขประจำตัวผู้เสียภาษี"
                    outline
                    :rules="[(v) => !!v || '', rules.lessThan13]"
                    counter="13"
                    v-model="form.bill_issuer_tax_id"
                  ></v-text-field></v-flex
                ><v-flex xs12 sm5 class="px-4 pt-3">
                  <v-text-field
                    label="เลขที่ใบกำกับ"
                    placeholder="ระบุเลขที่ใบกำกับ"
                    outline
                    :rules="[(v) => !!v || '']"
                    v-model="form.bill_number"
                  ></v-text-field
                ></v-flex>
              </v-layout> </v-flex
            ><v-flex xs12 sm6>
              <v-layout wrap justify-space-between>
                <v-flex xs12 sm7 class="px-4 pt-3">
                  <v-text-field
                    label="เลขประจำตัวผู้เสียภาษี"
                    placeholder="ระบุเลขประจำตัวผู้เสียภาษี"
                    outline
                    :rules="[(v) => !!v || '', rules.lessThan13]"
                    counter="13"
                    v-model="form.bill_customer_tax_id"
                  ></v-text-field></v-flex
                ><v-flex xs12 sm5 class="px-4 pt-3">
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        label="Due date"
                        placeholder="Select due date"
                        outline
                        :rules="[(v) => !!v || '']"
                        v-on="on"
                        prepend-inner-icon="event"
                        v-model="computedDateFormatted"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="form.bill_due_date"
                      no-title
                      @input="menu1 = false"
                      :min="moment().format('YYYY-MM-DD')"
                    ></v-date-picker> </v-menu
                ></v-flex>
              </v-layout> </v-flex
          ></v-layout>
          <hr class="new2 my-4" />
          <div v-if="form.bill_type == 1">
            <h3>รายละเอียดค่าใช้จ่าย</h3>
            <div class="pa-3 mt-3" style="background-color: #dbdbdb">
              <div
                style="display: flex"
                v-for="(info, index) in form.bill_detail"
                :key="index"
              >
                <v-layout wrap>
                  <v-flex xs12 sm5 class="px-3">
                    <v-text-field
                      v-model="info.name"
                      label="รายละเอียด"
                      placeholder="ระบุรายละเอียด"
                      outline
                      :rules="[(v) => !!v || '', rules.lessThan255]"
                      counter="255"
                      class="custom__input__invoice"
                    ></v-text-field
                  ></v-flex>
                  <v-flex xs12 sm3 class="px-3">
                    <v-text-field
                      v-model="info.unit"
                      label="จำนวน"
                      placeholder="ระบุจำนวนที่ต้องการ"
                      outline
                      :rules="[(v) => !!v || '', rules.positiveNumber]"
                      type="number"
                      class="custom__input__invoice"
                    ></v-text-field
                  ></v-flex>
                  <v-flex xs12 sm4 class="px-3">
                    <v-text-field
                      label="หน่วยละ"
                      placeholder="ระบุราคาต่อหน่วย"
                      outline
                      :rules="[(v) => !!v || '', rules.positiveNumber]"
                      type="number"
                      class="custom__input__invoice"
                      v-model="info.price"
                      @input="calculateNetPrice()"
                    ></v-text-field></v-flex
                ></v-layout>
                <v-btn
                  v-if="index == 0"
                  icon
                  color="success"
                  @click="
                    form.bill_detail.push({
                      name: '',
                      unit: '1',
                      price: '0',
                    });
                    calculateNetPrice();
                  "
                  ><v-icon>add</v-icon></v-btn
                >
                <v-btn
                  v-else
                  icon
                  color="error"
                  @click="
                    form.bill_detail.splice(index, 1);
                    calculateNetPrice();
                  "
                  ><v-icon>remove</v-icon></v-btn
                >
              </div>
            </div>
            <v-layout wrap class="mt-3">
              <v-flex xs12 sm2 class="px-2">
                <v-text-field
                  label="ส่วนลด"
                  placeholder="ระบุส่วนลด"
                  outline
                  :rules="[(v) => v == '0' || !!v || '', rules.positiveNumber]"
                  type="number"
                  v-model="form.bill_discount_price"
                  @input="calculateNetPrice()"
                ></v-text-field
              ></v-flex>
              <v-flex xs12 sm2 class="px-2">
                <v-text-field
                  label="มัดจำ"
                  placeholder="ระบุมัดจำ"
                  outline
                  :rules="[(v) => v == '0' || !!v || '', rules.positiveNumber]"
                  type="number"
                  v-model="form.bill_deposit_price"
                  @input="calculateNetPrice()"
                ></v-text-field
              ></v-flex>
              <v-flex xs12 sm2 class="px-2">
                <v-text-field
                  label="ภาษี 7%"
                  placeholder="0"
                  outline
                  :rules="[(v) => v == '0' || !!v || '']"
                  type="number"
                  v-model="form.bill_vat_price"
                  disabled
                ></v-text-field
              ></v-flex>
              <v-flex xs12 sm2 class="px-2">
                <v-text-field
                  label="ยอดรวมทั้งหมด"
                  placeholder="0"
                  outline
                  :rules="[(v) => v == '0' || !!v || '']"
                  type="number"
                  v-model="form.bill_net_price"
                  disabled
                ></v-text-field
              ></v-flex>
              <v-flex xs12 sm4 class="px-2">
                <v-text-field
                  label="ตัวอักษร"
                  placeholder="ระบุตัวอักษรของยอดรวมทั้งหมด"
                  outline
                  :rules="[(v) => v == '0' || !!v || '']"
                  v-model="form.bill_net_price_text"
                ></v-text-field
              ></v-flex>
            </v-layout>
          </div>
          <div v-else-if="form.bill_type == 2">
            <h3>รายละเอียดค่าใช้จ่าย</h3>
            <v-layout wrap class="mt-3">
              <v-flex xs12 sm9>
                <div class="pa-3" style="background-color: #dbdbdb">
                  <div
                    style="display: flex"
                    v-for="(info, index) in form.bill_detail"
                    :key="index"
                  >
                    <v-layout wrap>
                      <v-flex xs12 sm8 class="px-3">
                        <v-text-field
                          v-model="info.name"
                          label="รายละเอียด"
                          placeholder="ระบุรายละเอียด"
                          outline
                          :rules="[(v) => !!v || '', rules.lessThan255]"
                          counter="255"
                          class="custom__input__invoice"
                        ></v-text-field
                      ></v-flex>
                      <v-flex xs12 sm4 class="px-3">
                        <v-text-field
                          label="จำนวนเงิน"
                          placeholder="ระบุจำนวนเงิน"
                          outline
                          :rules="[(v) => !!v || '']"
                          type="number"
                          class="custom__input__invoice"
                          v-model="info.price"
                          @input="calculateNetPrice()"
                        ></v-text-field></v-flex
                    ></v-layout>
                    <v-btn
                      v-if="index == 0"
                      icon
                      color="success"
                      @click="
                        form.bill_detail.push({
                          name: '',
                          unit: '1',
                          price: '0',
                        })
                      "
                      ><v-icon>add</v-icon></v-btn
                    >
                    <v-btn
                      v-else
                      icon
                      color="error"
                      @click="form.bill_detail.splice(index, 1)"
                      ><v-icon>remove</v-icon></v-btn
                    >
                  </div>
                </div></v-flex
              >
              <v-flex xs12 sm3>
                <v-layout wrap class="mt-3">
                  <v-flex xs12 class="px-2">
                    <v-text-field
                      label="ยอดรวมทั้งหมด"
                      placeholder="0"
                      outline
                      :rules="[(v) => !!v || '']"
                      type="number"
                      v-model="form.bill_net_price"
                      disabled
                    ></v-text-field
                  ></v-flex>
                  <v-flex xs12 class="px-2">
                    <v-text-field
                      label="ตัวอักษร"
                      placeholder="ระบุตัวอักษรของยอดรวมทั้งหมด"
                      outline
                      :rules="[(v) => !!v || '']"
                      v-model="form.bill_net_price_text"
                    ></v-text-field
                  ></v-flex> </v-layout></v-flex
            ></v-layout>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <div class="pr-4">
          <v-btn
            class="button__actions"
            small
            color="#1492E6"
            @click="resetForm()"
            :disabled="isSubmit"
            >RESET</v-btn
          >
        </div>

        <v-btn
          class="button__actions"
          small
          color="success"
          @click="submit()"
          :disabled="!valid"
          :loading="isSubmit"
          >CONFIRM</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      valid: true,
      billTypeList: [
        {
          bill_type_id: 1,
          bill_type_name: "ใบแจ้งชำระหนี้",
          bill_type_status: 1,
        },
        {
          bill_type_id: 2,
          bill_type_name: "ใบแจ้งชำระหนี้ของ rider",
          bill_type_status: 1,
        },
      ],
      date: new Date().toISOString(),
      menu1: false,
      form: {},
      districtList: [],
      isLoadingDistrict: false,
      isLoading: false,
      rules: {
        lessThan255: (value) => value.length <= 255 || "",
        lessThan150: (value) => value.length <= 150 || "",
        lessThan50: (value) => value.length <= 50 || "",
        lessThan13: (value) => value.length <= 13 || "",
        positiveNumber: (value) => value >= 0 || "",
      },
      isSubmit: false,
    };
  },
  async created() {
    this.isLoading = true;
    let result = await this.getInvoiceManagerByID({
      manager_id: this.$route.params.manager_id,
      invoice_id: this.$route.params.invoice_id,
    });
    this.form = JSON.parse(JSON.stringify(result));
    this.form.bill_type = result.bill_type.bill_type_id;
    this.isLoading = false;
    await this.getDistrictList();
  },
  watch: {},
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.form.bill_due_date);
    },
  },
  methods: {
    ...mapActions({
      getDistrictCore: "fetchProvinceBack/getDistrictCore",
      editInvoiceManager: "invoice/editInvoiceManager",
      getInvoiceManagerByID: "invoice/fetchInvoiceManagerByID",
    }),
    formatDate(date) {
      if (!date) return null;

      return moment(date).format("DD/MM/YYYY");
    },
    resetForm() {
      this.form = {
        bill_type: 1,
        bill_provider: "manager",
        bill_number: "",
        bill_description: "",
        bill_issuer_name: "",
        bill_issuer_address: "",
        bill_issuer_tax_id: "",
        bill_customer_name: "",
        bill_customer_address: "",
        bill_customer_tax_id: "",
        bill_user_partner_id: this.$route.params.manager_id,
        bill_detail: [
          {
            name: "",
            unit: "1",
            price: "0",
          },
        ],
        bill_district_id: null,
        bill_amount_price: "0",
        bill_discount_price: "0",
        bill_deposit_price: "0",
        bill_vat_price: "0",
        bill_net_price: "0",
        bill_net_price_text: "",
        bill_due_date: null,
      };
    },
    async getDistrictList() {
      this.isLoadingDistrict = true;
      this.districtList = [];
      this.districtList = await this.getDistrictCore(
        this.$route.params.province_id
      );
      this.isLoadingDistrict = false;
    },

    async submit() {
      if (!this.$refs.forms.validate()) return;
      this.isSubmit = true;
      let result = await this.editInvoiceManager({ form: this.form });
      this.isSubmit = false;
      if (result == false) return;
      this.$router.replace({
        path: `/weserve_admin_login/-/manager-manage/${this.$route.params.manager_id}/${this.$route.params.manager_name}/${this.$route.params.province_id}/invoice`,
      });
    },
    changeInvoiceType() {
      this.form.bill_detail = [
        {
          name: "",
          unit: "1",
          price: "0",
        },
      ];
      this.form.bill_amount_price = "0";
      this.form.bill_discount_price = "0";
      this.form.bill_deposit_price = "0";
      this.form.bill_vat_price = "0";
      this.form.bill_net_price = "0";
      this.form.bill_net_price_text = "";
    },
    calculateNetPrice() {
      this.form.bill_amount_price = this.form.bill_detail.reduce(
        (previousValue, currentValue) =>
          parseFloat(previousValue) +
          parseFloat(currentValue.price) * parseFloat(currentValue.unit),
        0
      );
      this.form.bill_vat_price =
        ((parseFloat(this.form.bill_amount_price) -
          (parseFloat(this.form.bill_discount_price) || 0) -
          (parseFloat(this.form.bill_deposit_price) || 0)) *
          7) /
        100;
      this.form.bill_net_price =
        parseFloat(this.form.bill_amount_price) -
        (parseFloat(this.form.bill_discount_price) || 0) -
        (parseFloat(this.form.bill_deposit_price) || 0) +
        (this.form.bill_type == 1 ? parseFloat(this.form.bill_vat_price) : 0);
    },
  },
};
</script>

<style scoped>
hr.new2 {
  border-top: 1px dashed #9e9e9e;
}

input[type="number"] {
  -moz-appearance: textfield;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.button__actions {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 6px;
  color: white;
  font-weight: bold;
  font-size: 16px;
  width: 130px;
  height: 35px;
}
</style>

<style>
.custom__input__invoice .v-input__control .v-input__slot {
  background-color: white !important;
}
</style>
